// Application-wide constants. Import from here rather than inlining magic values.

// Conversion limits
export const GUEST_DEMO_LIMIT = 3;
export const SIGNUP_DEMO_LIMIT = 10;

// Subscription polling delays (ms) after a successful Stripe checkout.
// Stripe webhooks can take several seconds to reach the backend.
export const SUBSCRIPTION_POLL_DELAYS_MS = [2000, 4000, 7000, 10000, 15000, 20000, 30000];

// After this many ms of polling without confirmation, show a "still verifying" message.
export const SUBSCRIPTION_LONG_VERIFY_THRESHOLD_MS = 10000;

// Retry configuration for axiosRetry
export const AXIOS_RETRY_MAX_ATTEMPTS = 3;
export const AXIOS_RETRY_BASE_DELAY_MS = 300;

// Auth modes
export const AUTH_MODES = /** @type {const} */ ({ SUBSCRIPTION: 'subscription', PASSWORD: 'password' });

// File limits
export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024; // 10 MB — applies to free/guest tier only
export const PAID_PLAN_MAX_FILES = 50;

// Support
export const SUPPORT_EMAIL = 'contact.msgtopdfconverter@gmail.com';

// UI timing
export const SNACKBAR_AUTO_HIDE_MS = 3000;
export const TEAM_MEMBER_POLL_INTERVAL_MS = 5000;
export const GOOGLE_BUTTON_RENDER_POLL_MS = 300;
export const GOOGLE_BUTTON_RENDER_MAX_ATTEMPTS = 50;

// Plan tier ordering — used for upgrade/downgrade comparisons
export const PLAN_TIER_ORDER = { free: 0, starter: 1, pro: 2, team: 3 };
